<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      :title="$t('ORDER_DETAIL')"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/orders',breadcrumbName:$t('ORDER_LIST')}
      ,{path:`/orders/${orderId}`,breadcrumbName:$t('ORDER_DETAIL')}
      ] } }"
    />
    <div
      style="position: relative;
          line-height: 46px;
          height: 46px;
          background: #ffffff;
          white-space: nowrap;
          border: 0;
          border-bottom: 1px solid #e8e8e8;
          -webkit-box-shadow: none;
          box-shadow: none;">
      <a-space style="padding-left: 20px;font-weight: 700">
        #{{ form.data.orderNo }}
        <a-tag color="pink" v-if="form.data.status === 'UN_PAID'">
          {{ $t('UN_PAID') }}
        </a-tag>
        <a-tag color="red" v-if="form.data.status === 'UN_SHIPPED'">
          {{ $t('UN_SHIPPED') }}
        </a-tag>
        <a-tag color="orange" v-if="form.data.status === 'TO_BE_SHIPPED'">
          {{ $t('TO_BE_SHIPPED') }}
        </a-tag>
        <a-tag color="green" v-if="form.data.status === 'TRANSACTION_COMPLETED'">
          {{ $t('TRANSACTION_COMPLETED') }}
        </a-tag>
        <a-tag color="cyan" v-if="form.data.status === 'APPLY_REFUND'">
          {{ $t('APPLY_REFUND') }}
        </a-tag>
        <a-tag color="blue" v-if="form.data.status === 'REFUND'">
          {{ $t('REFUND') }}
        </a-tag>
        <a-tag color="purple" v-if="form.data.status === 'REFUND_COMPLETED'">
          {{ $t('REFUND_COMPLETED') }}
        </a-tag>
        <a-tag color="#6f6f6f" v-if="form.data.status === 'CANCEL'">
          {{ $t('CANCEL') }}
        </a-tag>
      </a-space>
      <a-space style="position: absolute;right: 8px;">
        <a-button-group>
          <a-button :disabled="!prevId" @click="()=>{$router.push(`/order/${prevId}/detail`)}">
            <a-icon type="left"/>
          </a-button>
          <a-button :disabled="!nextId" @click="()=>{$router.push(`/order/${nextId}/detail`)}">
            <a-icon type="right"/>
          </a-button>
        </a-button-group>
<!--        <a-button type="danger" @click="()=>{refundForm.visible = true}" v-if="form.data.status === 'UN_SHIPPED' || form.data.status === 'TRANSACTION_COMPLETED' " >退款 </a-button> >-->
        <a-button @click="()=>{$router.go(-1)}">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <div style="padding: 16px">
      <a-row :gutter="24">
        <a-col span="24"></a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-card
            title="订单">
            <a-descriptions
              :column="5"
              :title="detail.goodsSKU.name"
              :key="detail.id"
              v-for="detail in form.data.goodsOrderDetails">
              <a-descriptions-item label="">
                <a-avatar :src="detail.goodsSKU.image"/>
              </a-descriptions-item>
              <a-descriptions-item label="">
                {{ detail.goodsSKU.name }}
                <a-divider type="vertical"/>
                {{ detail.goodsSKU.specs }}
              </a-descriptions-item>
              <a-descriptions-item label="编号">
                {{ detail.goodsSKU.code }}
              </a-descriptions-item>
              <a-descriptions-item label="数量">
                ×{{ detail.quantity }}
              </a-descriptions-item>
              <a-descriptions-item label="金额">
                ×{{ detail.amount }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card style="margin-top: 16px" title="付款信息">
            <a-descriptions>
              <a-descriptions-item label="商品总计">
                {{ form.data.amount }}
              </a-descriptions-item>
              <a-descriptions-item label="运费">
                {{ form.data.postage }}
              </a-descriptions-item>
              <a-descriptions-item label="总金额">
                {{ form.data.totalAmount }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card style="margin-top: 16px" title="订单状态变化">
            <order-status-change
            :goodsOrderId="orderId"/>
          </a-card>

          <a-card style="margin-top: 16px" title="物流信息">
            <a-descriptions>
              <a-descriptions-item label="顺丰" :key="item.id" v-for="item in table.data">
                <span style="padding-right: 20px">#{{ item.expressNo }}  </span>
                <a-tag color="#108ee9">{{ $t(item.status) }}</a-tag>
                <a-button type="link" @click="GetOrderExpressTrack(item.id)">获取物流详情</a-button>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card style="margin-top: 16px" title="退款信息">
            <div :key="order.id" v-for="order in refundTable.data">
              <div> {{ order.createAt }}
                <a-divider type="vertical"/>
                {{ order.cause }}
              </div>
              <a-descriptions
                :column="5"
                :key="item.id"
                v-for="item in order.goodsOrderRefundDetails"
                :title="`${item.goodsSKU.name }`">
                <a-descriptions-item label="">
                  <a-avatar :src="item.goodsSKU.image"/>
                </a-descriptions-item>
                <a-descriptions-item label="">
                  {{ item.goodsSKU.name }}
                  <a-divider type="vertical"/>
                  {{ item.goodsSKU.specs }}
                </a-descriptions-item>
                <a-descriptions-item label="编号">
                  {{ item.goodsSKU.code }}
                </a-descriptions-item>
                <a-descriptions-item label="数量">
                  <span style="color: red">-{{ item.quantity }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="金额">
                  <span style="color: red">-{{ item.refundAmount }}</span>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card title="客户信息">
            <a slot="extra" @click="editDeliverInfo" href="javascript:void(0)">修改发货信息</a>
            <div>
              <a-descriptions title="账号" :column="1">
                <a-descriptions-item label="Name">
                  {{ form.data.user ? form.data.user.nickname : '' }}
                </a-descriptions-item>
                <a-descriptions-item label="Phone">
                  {{ form.data.user ? form.data.user.telephone : '' }}
                </a-descriptions-item>
              </a-descriptions>
              <a-descriptions title="发货信息" :column="1">
                <a-descriptions-item label="Name">
                  {{ form.data.name }}
                </a-descriptions-item>
                <a-descriptions-item label="Phone">
                  {{ form.data.mobile }}
                </a-descriptions-item>
                <a-descriptions-item label="Address">
                  {{ form.data.address }}
                </a-descriptions-item>
                <a-descriptions-item label="District">
                  {{ form.data.district }}
                </a-descriptions-item>
                <a-descriptions-item label="City">
                  {{ form.data.city }}
                </a-descriptions-item>
                <a-descriptions-item label="Province">
                  {{ form.data.province }}
                </a-descriptions-item>
                <a-descriptions-item label="Zip code">
                  {{ form.data.zipCode }}
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      title="退款"
      @ok="confirmRefund"
      v-model="refundForm.visible"
    :width="1200"
    :confirmLoading = "refundForm.loading">
      <a-form-model ref="refundForm" :rules="refundForm.rules" :model="refundForm.data">
        <a-table rowKey="goodsSKU.id" :pagination="false" :data-source="refundForm.data.details">
          <a-table-column>
            <template slot-scope="text, record">
              <a-checkbox v-model="record.isChecked">
              </a-checkbox>
            </template>
          </a-table-column>
          <a-table-column>
            <template slot-scope="text, record">
              <a-avatar :src="record.goodsSKU.image"/>
            </template>
          </a-table-column>
          <a-table-column
            title="商品">
            <template slot-scope="text, record">
              {{ record.goodsSKU.name }}/{{ record.goodsSKU.specs }}
            </template>
          </a-table-column>
          <a-table-column
            title="商品详情">
            <template slot-scope="text, record">
              {{ record.currentUnitPrice }} ×{{ record.quantity }}
            </template>
          </a-table-column>
          <a-table-column
            title="订单金额">
            <template slot-scope="text, record">
              {{ record.amount }}
            </template>
          </a-table-column>
          <!-- <a-table-column
            title="已退金额">
            <template slot-scope="text, record">
              {{ record.amount - record.limitAmount }}// {{ record.limitAmount }}
            </template>
          </a-table-column> -->
          <a-table-column
            title="退款数量">
            <template slot-scope="text, record">

                {{record.refundQuantity}}

            </template>
          </a-table-column>
          <!-- <a-table-column
            title="退款金额">
            <template slot-scope="text, record">
              <a-input-number
                v-model="record.refundAmount"
                :step="1"
                :min="0"
                :max="record.limitAmount"></a-input-number>
            </template>
          </a-table-column> -->
        </a-table>
        <a-form-model-item label="退款原因" prop="cause">
          <a-input v-model="refundForm.data.cause"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="deliverForm.visible" :footer="null">
      <a-form-model ref="form" :model="deliverForm.data" :rules="deliverForm.rules">
        <a-form-model-item :label="$t('PROVINCE')">
          <a-input v-model="deliverForm.data.province"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('CITY')">
          <a-input v-model="deliverForm.data.city"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('DISTRICT')">
          <a-input v-model="deliverForm.data.district"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('ZIP_CODE')">
          <a-input v-model="deliverForm.data.zipCode"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('ADDRESS')">
          <a-input v-model="deliverForm.data.address"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('NAME')">
          <a-input v-model="deliverForm.data.name"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('PHONE')">
          <a-input v-model="deliverForm.data.mobile"/>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click="saveDeliverInfo">更新</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
    v-model="orderExpressForm.visible"
    title="订单物流详情"
    :footer="null">
      <order-express-track
      class="express-form"
      :goodsOrderExpressId="orderExpressId"
      />
    </a-modal>

  </div>
</template>

<script>
import {
  _queryOrder,
  _queryOrderPosition,
  _refundOrderDetail,
  _queryRefundOrders,
  _updateOrderDeliverInfo,
} from '@/api/orderApi';
import { _queryOrderExpresss } from '@/api/orderExpressApi';
import OrderExpressTrack from '../orderExpress/OrderExpressTrack.vue';
import OrderStatusChange from '@/components/OrderStatusChange.vue';

async function getOrder() {
  const result = await _queryOrder(this.orderId);
  if (result) {
    this.form.data = result;
  }
  const refundOrders = await _queryRefundOrders(this.orderId);
  this.refundTable.data = refundOrders;
  const positionResult = await _queryOrderPosition(this.orderId);
  this.nextId = positionResult.next;
  this.prevId = positionResult.prev;
  this.getOrderExpressList();
  const refundAmountByDetailId = new Map();
  const refundQuantityByDetailId = new Map();
  refundOrders.forEach((item) => {
    item.goodsOrderRefundDetails.forEach((x) => {
      if (!refundAmountByDetailId.has(x.orderDetailId)) {
        refundAmountByDetailId.set(x.orderDetailId, 0);
      }
      refundAmountByDetailId
        .set(x.orderDetailId, refundAmountByDetailId.get(x.orderDetailId) + x.refundAmount);
      if (!refundQuantityByDetailId.has(x.orderDetailId)) {
        refundQuantityByDetailId.set(x.orderDetailId, 0);
      }
      refundQuantityByDetailId
        .set(x.orderDetailId, refundQuantityByDetailId.get(x.orderDetailId) + x.quantity);
    });
  });

  this.refundForm.data.details = result.goodsOrderDetails.map(x => ({
    isChecked: false,
    detailId: x.id,
    goodsSKU: x.goodsSKU,
    currentUnitPrice: x.currentUnitPrice,
    amount: x.amount,
    refundAmount: x.amount,
    limitAmount: x.amount - (refundAmountByDetailId.get(x.id) || 0),
    quantity: x.quantity,
    limitQuantity: x.quantity - (refundQuantityByDetailId.get(x.id) || 0),
    refundQuantity: x.quantity,
    refundType: 'RETURN_REFUND',
  }));
}

function GetOrderExpressTrack(id) {
  this.orderExpressId = id;
  this.orderExpressForm.visible = true;
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

async function getOrderExpressList() {
  const result = await _queryOrderExpresss({
    page: 1,
    orderId: this.orderId,
    size: 20,
  });
  this.table.data = result;
}

function editDeliverInfo() {
  this.deliverForm.data.address = this.form.data.address;
  this.deliverForm.data.zipCode = this.form.data.zipCode;
  this.deliverForm.data.province = this.form.data.province;
  this.deliverForm.data.district = this.form.data.district;
  this.deliverForm.data.city = this.form.data.city;
  this.deliverForm.data.mobile = this.form.data.mobile;
  this.deliverForm.data.name = this.form.data.name;
  this.deliverForm.visible = true;
}

async function saveDeliverInfo() {
  const result = await _updateOrderDeliverInfo(this.orderId, {
    address: this.deliverForm.data.address,
    zipCode: this.deliverForm.data.zipCode,
    province: this.deliverForm.data.province,
    city: this.deliverForm.data.city,
    mobile: this.deliverForm.data.mobile,
    district: this.deliverForm.data.district,
    name: this.deliverForm.data.name,
  });
  if (result) {
    this.deliverForm.visible = false;
    this.$message.success(this.$t('UPDATE_SUCCESS'));
    this.getOrder();
  }
}

function confirmRefund() {
  this.refundForm.loading = true;

  const refundItems = this.refundForm.data.details
    .filter(x => x.isChecked && x.refundQuantity > 0);

  this.$refs.refundForm.validate(async (valid) => {
    if (refundItems.length > 0 && valid) {
      const refundDetails = refundItems.map(x => ({
        refundAmount: x.refundAmount,
        refundQuantity: x.refundQuantity,
        detailId: x.detailId,
        skuId: x.goodsSKU.id,
      }));
      const result = await _refundOrderDetail(this.orderId, {
        cause: this.refundForm.data.cause,
        details: refundDetails,
      });
      if (result) {
        this.$message.success('退款成功!');
        this.refundForm.visible = false;
        this.refundForm.loading = false;
        if (this.orderId) {
          this.getOrder();
        }
      }
    }
  });
}

export default {
  components: { OrderExpressTrack, OrderStatusChange },
  name: 'OrderDetail',
  props: {
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    orderId() {
      if (this.orderId) {
        this.getOrder();
      }
    },
  },
  methods: {
    onCancel,
    getOrder,
    getOrderExpressList,
    confirmRefund,
    editDeliverInfo,
    saveDeliverInfo,
    GetOrderExpressTrack,
  },
  data() {
    return {
      orderExpressId: '',
      prevId: '',
      nextId: '',
      table: {
        data: [],
      },
      refundTable: {
        data: [],
      },
      orderExpressForm: {
        visible: false,
      },
      deliverForm: {
        visible: false,
        data: {
          city: '',
          name: '',
          district: '',
          address: '',
          province: '',
          zipCode: '',
          mobile: '',
        },
      },
      refundForm: {
        visible: false,
        loading: false,
        data: {
          cause: '',
          details: [],
        },
        rules: {
          cause: [{ required: true }],
        },
      },
      form: {
        data: {
          id: '',
          orderNo: '',
          goodsDescription: '',
          image: '',
          amount: 0,
          point: 0,
          userId: '',
          status: '',
          province: '',
          city: '',
          mobile: '',
          address: '',
          name: '',
          district: '',
          zipCode: '',
          aging: 0,
          postage: 0,
          discount: 0,
          totalAmount: 0,
          totalQuantity: 0,
          nonceStr: '',
          signType: '',
          outTradeNo: null,
          outRefundNo: null,
          remark: null,
          user: {
            id: '',
            isDeleted: 0,
            createAt: null,
            nickname: '**********',
            avatar: '',
            remark: null,
            grade: 'NORMAL',
            telephone: '',
            gender: '2',
            consumptionAmount: 0.00,
            points: 0.00,
            birthday: '2020-08-07',
          },
          goodsOrderDetails: [{
            id: '1363739554208681984',
            isDeleted: 0,
            createAt: '2021-02-22T14:37:01',
            updateAt: '2021-02-22T14:37:01',
            userId: null,
            skuId: '1347021653674168320',
            orderId: '1363739554170933248',
            quantity: 1,
            currentUnitPrice: 399.00,
            amount: 399.00,
            discount: 1.00,
            orderAmount: 399.00,
            goodsSKU: {
              id: '1347021653674168320',
              isDeleted: 0,
              createAt: '2021-01-07T11:26:03',
              updateAt: '2021-02-22T01:01:20',
              wdtId: '7253',
              goodsId: '1347021126924111872',
              price: 399.00,
              listPrice: null,
              code: '21SS3439GBS00000',
              description: null,
              name: '编辑空间皮革挂包',
              quantity: 24,
              storageBin: '',
              image: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210115-1349905766160666624.png',
              images: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210115-1349905723131301888.jpg,https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210115-1349905723106136064.jpg',
              isActive: 'YES',
              specs: '均码,米色灰色',
              modelImages: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210118-1351061609128267776.jpg,https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210118-1351061702346674176.jpg,https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210118-1351061702455726080.jpg',
              modelSizeImage: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210115-1349908208612937728.jpg',
              modelSizeDetail: null,
              detail: null,
              sortWeight: 21,
              goodsSkuAttributeValues: [{
                id: '1347021653690945536',
                isDeleted: 0,
                createAt: '2021-01-07T11:26:03',
                updateAt: '2021-01-07T11:26:03',
                skuId: '1347021653674168320',
                attributeValueId: '1347021653586087936',
                goodsId: '1347021126924111872',
                goodsAttributeValue: {
                  id: '1347021653586087936',
                  isDeleted: 0,
                  createAt: '2021-01-07T11:26:03',
                  updateAt: '2021-02-22T01:00:17',
                  attributeId: '1363534014811607040',
                  value: '均码',
                  goodsId: '1347021126924111872',
                  attributeCode: 'size',
                  imgPath: null,
                  isActive: 'YES',
                  sort: null,
                  extra: null,
                  goodsAttribute: {
                    id: '1363534014811607040',
                    isDeleted: 0,
                    createAt: '2021-02-22T01:00:17',
                    updateAt: '2021-02-22T01:00:17',
                    goodsId: '1347021126924111872',
                    categoryId: null,
                    name: '尺寸',
                    code: 'size',
                    isActive: 'YES',
                  },
                },
              }, {
                id: '1347021653707722752',
                isDeleted: 0,
                createAt: '2021-01-07T11:26:03',
                updateAt: '2021-01-07T11:26:03',
                skuId: '1347021653674168320',
                attributeValueId: '1347021653615448064',
                goodsId: '1347021126924111872',
                goodsAttributeValue: {
                  id: '1347021653615448064',
                  isDeleted: 0,
                  createAt: '2021-01-07T11:26:03',
                  updateAt: '2021-02-22T01:00:17',
                  attributeId: '1363534014773858304',
                  value: '米色灰色',
                  goodsId: '1347021126924111872',
                  attributeCode: 'color',
                  imgPath: null,
                  isActive: 'YES',
                  sort: null,
                  extra: null,
                  goodsAttribute: {
                    id: '1363534014773858304',
                    isDeleted: 0,
                    createAt: '2021-02-22T01:00:17',
                    updateAt: '2021-02-22T01:00:17',
                    goodsId: '1347021126924111872',
                    categoryId: null,
                    name: '颜色',
                    code: 'color',
                    isActive: 'YES',
                  },
                },
              }],
              goods: {
                id: '1347021126924111872',
                sort: null,
                isDeleted: 0,
                createAt: '2021-01-07T11:23:58',
                updateAt: '2021-03-02T01:04:06',
                wdtId: null,
                name: '编辑空间皮革挂包',
                nameEn: 'RANDOMEVENT POUCH',
                code: '21SS3439',
                weight: 0,
                styleQuantity: 1,
                categoryId: '1273873459562287104',
                description: '采用环保PU皮，满幅印花。搭配金属链条，增加质感。',
                seriesId: '',
                tip: null,
                detail: '',
                sizeImage: '',
                brandId: '1273548452214738944',
                coverPath: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210115-1349904807195971584.png',
                images: '',
                basicSpec: 'color',
                qrCode: null,
                storageBin: '',
                isLimited: 'NO',
                isFavourable: 'YES',
                limitedQuantity: 0,
                status: 'OFF',
                sellStartAt: '2021-01-25T00:00:00',
                salesQuantity: 9,
                price: 399.00,
                listPrice: 399.00,
                memberOnly: 'NO',
                modelSizeImage: null,
                help: '下单后 24h 内发货。',
                sizeImageDetail: '',
                brand: {
                  id: '1273548452214738944',
                  isDeleted: 0,
                  createAt: '2020-06-18T17:29:47',
                  updateAt: '2021-01-13T17:56:31',
                  name: 'RDET',
                  coverPath: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210113-1349294236314505216.jpg',
                  description: 'Randomevent',
                },
                category: {
                  id: '1273873459562287104',
                  sort: null,
                  isDeleted: 0,
                  createAt: '2020-06-19T15:01:15',
                  updateAt: '2021-01-20T10:46:32',
                  name: '箱包',
                  nameEn: 'BAG',
                  coverPath: 'https://rdet-oss.oss-cn-hangzhou.aliyuncs.com/20210120-1351722743485304832.png',
                  parentId: '1273873389123145728',
                },
                series: null,
              },
            },
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.orderId) {
      this.getOrder();
    }
  },
};
</script>

<style scoped>
.express-form{
  width: 100%;
  height: 450px;
  overflow-y: auto;
  overflow-x: auto;
}
</style>
